<div class="address-detail-compact" *ngIf="addressId > 0 || isNewAddress">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-state">
    <span class="spinner-border spinner-border-sm text-primary"></span>
    <small class="ms-2 text-muted">Loading...</small>
  </div>

  <!-- Address Details -->
  <div *ngIf="!isLoading && (addressData || isNewAddress)" class="address-card">
    <div class="address-header bg-primary text-white">
      <small class="address-title">
        <i class="bi bi-geo-alt-fill"></i> {{ isNewAddress ? 'Add New Address' : 'Address Details' }}
      </small>
      <div class="btn-group-sm">
        <button 
          *ngIf="!isEditing" 
          class="btn btn-sm btn-light" 
          (click)="toggleEdit()"
          type="button">
          <i class="bi bi-pencil"></i>
        </button>
        <button 
          *ngIf="isEditing" 
          class="btn btn-sm btn-light" 
          (click)="onSave()"
          [disabled]="isSaving || addressForm.invalid"
          type="button">
          <span *ngIf="isSaving" class="spinner-border spinner-border-sm"></span>
          <i *ngIf="!isSaving" class="bi bi-check-lg"></i>
        </button>
        <button 
          *ngIf="isEditing" 
          class="btn btn-sm btn-light ms-1" 
          (click)="onCancel()"
          [disabled]="isSaving"
          type="button">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
    </div>
    
    <div class="address-body">
      <form [formGroup]="addressForm">
        <div class="row g-2">
          <div class="col-12">
            <label class="form-label-sm">Address Type</label>
            <input 
              type="text" 
              class="form-control form-control-sm" 
              formControlName="addressType"
              placeholder="Address Type">
          </div>
          <div class="col-12">
            <label class="form-label-sm">Address</label>
            <textarea 
              class="form-control form-control-sm" 
              formControlName="address" 
              rows="2"
              placeholder="Address"></textarea>
          </div>
          <div class="col-md-4">
            <label class="form-label-sm">City</label>
            <input 
              type="text" 
              class="form-control form-control-sm" 
              formControlName="city"
              placeholder="City">
          </div>
          <div class="col-md-4">
            <label class="form-label-sm">State</label>
            <input 
              type="text" 
              class="form-control form-control-sm" 
              formControlName="state"
              placeholder="State">
          </div>
          <div class="col-md-4">
            <label class="form-label-sm">Pincode</label>
            <input 
              type="text" 
              class="form-control form-control-sm" 
              formControlName="pincode"
              placeholder="Pincode">
          </div>
          <div class="col-md-4">
            <label class="form-label-sm">Gst No</label>
            <input 
              type="text" 
              class="form-control form-control-sm" 
              formControlName="gstNo"
              placeholder="Gst No">
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
